import { frontendURL } from '../../../helper/URLHelper';
import TicketsPageRouteView from './TicketsPageRouteView.vue';

const TicketListView = () => import('./TicketListView.vue');
const TicketDetailView = () => import('./TicketDetailView.vue');

const TICKET_PERMISSIONS = [
  'administrator',
  'agent',
  'ticket_view',
  'ticket_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    component: TicketsPageRouteView,
    children: [
      {
        path: '',
        name: 'tickets_list',
        meta: { permissions: TICKET_PERMISSIONS },
        component: TicketListView,
      },
      {
        path: ':ticketId',
        name: 'ticket_detail',
        meta: { permissions: TICKET_PERMISSIONS },
        component: TicketDetailView,
        props: route => ({ ticketId: route.params.ticketId }),
      },
    ],
  },
];
